import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 4h6v6h-6v-6","key":"svg-0"}],["path",{"d":"M14 4h6v6h-6v-6","key":"svg-1"}],["path",{"d":"M4 14h6v6h-6v-6","key":"svg-2"}],["path",{"d":"M14 17h6m-3 -3v6","key":"svg-3"}]]

const IconCategoryPlus = createReactComponent('outline', 'category-plus', 'CategoryPlus', __iconNode);

export default IconCategoryPlus;